/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { signInActions } from 'modules/sign-in/slice';
import { verifyCallbackActions } from 'modules/verify-callback/slice';

export const initialState = {
  user: {},
  tokens: {},
  organization: {},
  loading: false,
  resetPasswordToken: '',
  isTokenRevoked: false,
};
export const authSlice = createSlice({
  name: 'feature/base-auth',
  initialState,
  reducers: {
    fetchUser(state) {
      state.loading = true;
    },
    fetchUserSucceeded(state, action) {
      state.loading = false;
      state.user = action?.payload;
    },
    fetchUserFailed(state) {
      state.loading = false;
    },
    signOut(state) {
      state.loading = true;
    },
    signOutSucceeded(state) {
      state.loading = false;
      state.user = {};
      state.tokens = {};
    },
    signOutFailed(state) {
      state.loading = false;
      state.user = {};
      state.tokens = {};
    },
    removeAuth(state) {
      state.user = {};
      state.tokens = {};
      state.loading = false;
    },
    refreshToken(state) {
      state.loading = true;
    },
    refreshTokenSucceeded(state, action) {
      state.loading = false;
      state.tokens = action?.payload;
    },
    refreshTokenFailed(state) {
      state.loading = false;
    },
    setTokenRevocationError(state, action) {
      state.isTokenRevoked = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signInActions.signIn, (state) => ({
        ...state,
        ...initialState,
      }))
      .addCase(signInActions.signInSucceeded, (state, action) => ({
        ...state,
        tokens: action?.payload?.tokens,
        user: action?.payload?.user,
      }))
      .addCase(signInActions.signInFailed, (state) => ({
        ...state,
        tokens: {},
        user: {},
      }))
      .addCase(verifyCallbackActions.verifyTokenSucceeded, (state, action) => ({
        ...state,
        resetPasswordToken: action?.payload?.token,
      }))
      .addCase(verifyCallbackActions.verifyTokenFailed, (state) => ({
        ...state,
        resetPasswordToken: '',
      }));
  },
});

export const { actions: authActions } = authSlice;
